var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"2.5"},React.createElement("path",{"d":"M1.25 1.25h20M1.25 9.25h20M1.25 17.25h20"})));
}

Menu.defaultProps = {"width":"22.5","height":"18.5","data-name":"Layer 1","viewBox":"0 0 22.5 18.5"};

module.exports = Menu;

Menu.default = Menu;
